import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m418-420-87-87q-12-12-28-11-15 0-27 12t-12 27q0 16 12 27l114 113q12 12 28 12t28-12l240-241q12-11 12-27t-12-27q-11-12-27-12-15 0-27 12L418-420ZM185-106q-32 0-56-23-23-24-23-56v-590q0-33 23-56 24-24 56-24h590q33 0 56 24 24 23 24 56v590q0 32-24 56-23 23-56 23H185Zm0-79h590v-590H185v590Zm0-590v590-590Z"/>',
  f: '<path d="m418-420-87-87q-12-12-27-12t-27 12q-12 12-12 27 0 16 12 27l113 114q11 12 28 12 16 0 28-12l240-242q12-11 12-26 0-16-12-27-11-12-27-12-15 0-27 12L418-420ZM185-106q-32 0-56-23-23-24-23-56v-590q0-33 23-56 24-24 56-24h590q33 0 56 24 24 23 24 56v590q0 32-24 56-23 23-56 23H185Z"/>',
};

export default data;
